export default function cleanValues<T>(values: any): T {
  Object.keys(values).forEach((key) => {
    const k = key as keyof T;
    values[k] = typeof values[k] === 'string' ? `${values[k]}`.trim() : values[k];
  });

  return values;
}
